module.exports = __webpack_public_path__ + "media/process/Process-Badges-Careful-ff7ca75f.svg";